import styled from "styled-components";

export const Main = styled.div`
  width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  max-width: 520px;
  width: 100%;

  .select {
    h4 { width: 108px; }
  }
  .textInput {
    h4 {
      width: 125px;
    }
    &:not(:last-of-type) {
      margin-bottom: 10px;
    }
  } 
  .action {
    margin: 12px 0;
    border-bottom: 1px solid #e5e7eb;
  }

  .webhook-section {
    margin-bottom: 16px;
  }

  .webhook-section h4 {
    margin: 0 0 8px 0;
    color: #333;
    font-size: 14px;
    font-weight: 600;
  }

  .link-container {
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 10px;
    background: #f9fafb;
    cursor: pointer;
    max-width: 100%;
    overflow: hidden;
    transition: background 0.2s;
  }

  .link-container:hover {
    background: #f3f4f6;
  }

  .link-with-copy {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .copy-icon {
    color: #6b7280;
    font-size: 14px;
    flex-shrink: 0;
    transition: color 0.2s;
  }

  .copy-icon.copied {
    color: #10b981;
  }

  .link-text {
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
    font-size: 12px;
    color: #374151;
    word-break: break-all;
    overflow-wrap: break-word;
    white-space: normal;
    min-width: 0;
    flex: 1;
  }

  .watch-section {
    margin: 16px 0 0 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .watch-button {
    background: #323432ff;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all .2s ease-in-out;
  }

  .watch-button:hover:not(:disabled) {
    box-shadow: 0 0 10px #323432ff;
    opacity: 0.9;
  }

  .watch-button:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }

  .stop-watch-button {
    background: #ef4444;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background 0.2s;
    transition: all .2s ease-in-out;
  }

  .stop-watch-button:hover:not(:disabled) {
    background: #dc2626;
    box-shadow: 0 0 10px #dc2626;
    opacity: 0.9;
  }

  .stop-watch-button:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }

  .watch-status {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.4;
  }

  .watch-status.success {
    background: #d1fae5;
    color: #065f46;
    border: 1px solid #10b981;
  }

  .watch-status.error {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #ef4444;
  }

  .watch-info {
    margin: 16px 0 0;
    padding: 12px;
    background: #f0f9ff;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
  }

  .watch-info h5 {
    margin: 0 0 8px 0;
    color: #1e40af;
    font-size: 13px;
    font-weight: 600;
  }

  .watch-info ul {
    margin: 0;
    padding-left: 0;
    list-style: none;
  }

  .watch-info li {
    margin-bottom: 4px;
    font-size: 12px;
    color: #1e3a8a;
  }

  .watch-info strong {
    font-weight: 600;
  }

  .instructions-section {
    margin: 20px 0 0 0;
    padding-top: 16px;
    border-top: 1px solid #e5e7eb;
  }

  .instructions-section h5 {
    margin: 0 0 10px 0;
    color: #374151;
    font-size: 14px;
    font-weight: 600;
  }

  .steps-list {
    margin: 0 0 16px 0;
    padding-left: 20px;
    font-size: 13px;
    line-height: 1.6;
    color: #4b5563;
  }

  .steps-list li {
    margin-bottom: 8px;
  }

  .notes-list {
    margin: 0;
    padding-left: 20px;
    font-size: 12px;
    line-height: 1.6;
    color: #6b7280;
  }

  .notes-list li {
    margin-bottom: 6px;
  }

  .external-link {
    color: #2563eb;
    text-decoration: none;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .external-link:hover {
    text-decoration: underline;
  }
`;

export const Loader = styled.span`
  width: 68px;
  height: 68px;
  border: 5px solid #9ca3af;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: 0 auto;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;